import { meridianPoints } from '@/mocks/solutionsData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function MeridianSection() {
  return (
    <section className="relative bg-brand-gray py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]">
        <img
          src={readdy('meridian-bg-v2')}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <ScrollReveal variant="fade-right">
              <div className="inline-flex items-center gap-2 bg-brand-light px-4 py-2 rounded-full mb-6">
                <i className="ri-seedling-line text-brand-green" />
                <span className="text-xs font-medium text-brand-green">中医经络理论参考</span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep leading-tight mb-6">
                以传统智慧
                <br />
                滋养现代健康管理
              </h2>
              <p className="text-gray-500 text-sm leading-relaxed mb-8 max-w-lg">
                麦杰集团在服务理念中融入中医经络理论参考视角，将其作为理解
                人体整体健康状态的参考框架，融入健康评估与方案设计之中。
                我们强调：此为健康管理参考，不做医疗功效承诺。
              </p>

              <div className="space-y-5">
                {meridianPoints.map((point) => (
                  <div key={point.title} className="flex gap-4">
                    <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-brand-light">
                      <i className={`${point.icon} text-brand-deep`} />
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-brand-deep mb-1">{point.title}</h4>
                      <p className="text-gray-400 text-xs leading-relaxed">{point.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </ScrollReveal>

            <ScrollReveal variant="fade-left" delay={150}>
              <div className="relative">
                <div className="rounded-2xl overflow-hidden aspect-[4/5]">
                  <img
                    src={readdy('meridian-001')}
                    alt="中医经络理论参考"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-white/90 via-white/60 to-transparent p-6 rounded-b-2xl">
                  <p className="text-brand-deep text-sm font-medium">健康管理参考</p>
                  <p className="text-gray-400 text-xs mt-1">不做独立医疗承诺</p>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}